// extracted by mini-css-extract-plugin
export default {"story":"ProfileStory_story__AfENi","detail":"ProfileStory_detail__5nmn5"};